var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupplierAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAEFF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4963 12.5449V29.0028",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4961 24.5015C14.6974 23.2437 17.366 23.1089 19.6828 24.1386L21.3161 24.8645C23.6329 25.8942 26.3015 25.7594 28.5028 24.5015V12.5456C26.3015 13.8034 23.6329 13.9382 21.3161 12.9085L19.6828 12.1826C17.366 11.1529 14.6974 11.2877 12.4961 12.5456",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierAppointment);
export default __webpack_public_path__ + "static/media/SupplierAppointment.2477556936205de2666327ea47dbfd6b.svg";
export { ForwardRef as ReactComponent };